import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import routes from '../../routes'
import config from '../../config'
import { onDemand } from '../../constants/galleriumVideos'
import Amplitude from '../../utils/amplitudeHelper'

const MobileGalleriumPage = ({ currentUser }) => {
  
  useEffect(() => {
    document.title = `${config.eventName} | On-Demand`
  }, [])

  useEffect(() => {
    Amplitude.visit(`On-Demand`)
  }, [currentUser.id])

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="title-container">
            <p className="title">On-Demand</p>
            <Link className="back-button" to={routes.lobby}>
              Back
            </Link>
          </div>

          <div className="list-container">
            {onDemand.map((item) => (
              <Link className="list-item" key={item.name} to={item.destination}>
                <img alt="poster gallery item" src={item.thumbnail} className="list-image"/>
              </Link>
            ))}
          </div>
         
        </div>
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: white;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  border-radius: 0px 0px 25px 25px;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 90%;
    margin: auto;
  }

  .title-container {
    margin: 30px 0px 10px 0px;
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .title {
    width: 80%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }

  .back-button {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
    margin-top: 10px;
  }

  .list-container {
    width: 100%;
    column-count: 2;
  }

  .list-item {
    width: 100%;
  }

  .list-image {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .image-zoom {
    width: 100%;
  }
  .btn-container {
    display: flex;
    justify-content: center;
  }
  .gallery-btn {
    background-color: transparent;
    border: none;
    font-size: 15px;
    width: 90%;
    margin: 4px auto;
    font-weight: 500;
    color: #26B4A9;
    
    svg {
      width: 24px;
      margin-right: 6px;
    }
    &:hover {
      color: #3A2D86;
      path {
        fill: #3A2D86;
      }
    }
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileGalleriumPage
